import React, { useLayoutEffect, useRef, useState } from "react";
import { useApp } from "./common.jsx";
import { steps } from "./tour-data.js";
export function Tour() {
  const a = useApp(),
    [step, setStep] = useState(0),
    [rect, setRect] = useState(null),
    [pos, setPos] = useState({ left: 12, top: 12 }),
    ref = useRef(null);
  const ka = a.lang === "ka";
  const close = () => {
    a.setTour(false);
    a.setFiltersOpen(false);
  };
  useLayoutEffect(() => {
    if (step === 2 && innerWidth > 760) a.setSidebarCollapsed(false);
    a.setFiltersOpen(step === 2 && innerWidth <= 760);
    const layout = () => {
      const el = document.querySelector(steps[step][0]);
      if (!el) return;
      const r = el.getBoundingClientRect();
      setRect({
        left: Math.max(4, r.left - 6),
        top: Math.max(4, r.top - 6),
        width: Math.min(innerWidth - 8, r.width + 12),
        height: Math.min(innerHeight - 8, r.height + 12),
      });
      const w = Math.min(360, innerWidth - 24),
        h = ref.current?.offsetHeight || 300;
      let top = r.bottom + 20;
      if (top + h > innerHeight - 12) top = r.top - h - 20;
      top = Math.max(12, Math.min(top, innerHeight - h - 12));
      let left = Math.min(innerWidth - w - 12, Math.max(12, r.left));
      if (step === 2 && innerWidth > 760)
        left = Math.min(innerWidth - w - 12, r.right + 22);
      setPos({ left, top, width: w });
    };
    const el = document.querySelector(steps[step][0]);
    el?.scrollIntoView({ block: "nearest", behavior: "instant" });
    layout();
    const frame = requestAnimationFrame(() => {
      layout();
      ref.current?.querySelector("[data-tour-forward]")?.focus();
    });
    window.addEventListener("resize", layout);
    window.addEventListener("scroll", layout, true);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", layout);
      window.removeEventListener("scroll", layout, true);
    };
  }, [step, a.lang]);
  const next = () => (step === steps.length - 1 ? close() : setStep(step + 1));
  return (
    <div
      className="guided-tour"
      onKeyDown={(e) => {
        if (e.key === "Escape") close();
        if (e.key === "ArrowRight") next();
        if (e.key === "ArrowLeft") setStep(Math.max(0, step - 1));
        if (e.key === "Tab") {
          const buttons = [
              ...ref.current.querySelectorAll("button:not(:disabled)"),
            ],
            first = buttons[0],
            last = buttons.at(-1);
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }}
    >
      <div className="tour-shield" />
      <div className="tour-spotlight" style={rect || { display: "none" }} />
      <section
        className="tour-popover"
        ref={ref}
        style={pos}
        role="dialog"
        aria-modal="true"
        aria-labelledby="tour-title"
      >
        <div className="tour-topline">
          <span>FONTLAB · {ka ? "მოკლე ტური" : "QUICK TOUR"}</span>
          <button data-tour-exit onClick={close} aria-label="Close tour">
            ×
          </button>
        </div>
        <div className="tour-meter">
          <i style={{ width: ((step + 1) / steps.length) * 100 + "%" }} />
        </div>
        <p className="tour-counter">
          {step + 1} / {steps.length}
        </p>
        <h2 id="tour-title">{steps[step][ka ? 2 : 1]}</h2>
        <p id="tour-description">{steps[step][ka ? 4 : 3]}</p>
        <div className="tour-footer">
          <button data-tour-exit onClick={close}>
            {ka ? "გამოტოვება" : "Skip tour"}
          </button>
          <div>
            <button
              data-tour-back
              disabled={!step}
              onClick={() => setStep(step - 1)}
            >
              {ka ? "უკან" : "Back"}
            </button>
            <button className="tour-next" data-tour-forward onClick={next}>
              {step === steps.length - 1
                ? ka
                  ? "დავიწყოთ"
                  : "Let’s explore"
                : ka
                  ? "შემდეგი"
                  : "Next"}{" "}
              →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
